import { createContext, ReactNode, use } from "react";
import { GlobalSearchContextType } from "../types";
import { useViewModel } from "./useViewModel";

type Props = {
  children: ReactNode;
  open: boolean;
  onDismiss: () => void;
};

export const GlobalSearchContext = createContext<GlobalSearchContextType>(
  {} as GlobalSearchContextType,
);

export const GlobalSearchContextProvider = ({
  children,
  open,
  onDismiss,
}: Props) => {
  const { context } = useViewModel({ open, onDismiss });

  return <GlobalSearchContext value={context}>{children}</GlobalSearchContext>;
};

export const useGlobalSearchContext = () => {
  return use(GlobalSearchContext);
};
